if (!customElements.get('fader-slider')) {
    customElements.define(
      'fader-slider',
      class FaderSlider extends HTMLElement {
        constructor() {
          super();
          this.slides = this.querySelectorAll('.slide-fade');
          this.currentSlideIndex = 0;
          this.faderSpeed = parseInt(this.dataset.speed) * 1000
          this.slideFirst = document.querySelector('.slide-fade')
          this.fadeable = document.querySelector('.fadeable')
        }

        showNextSlide() {
            const currentSlide = this.slides[this.currentSlideIndex];
            currentSlide.classList.remove('active');

            this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
            const nextSlide = this.slides[this.currentSlideIndex];
            nextSlide.classList.add('active');
            // this.fadeable.style.width = nextSlide.dataset.width;

            setTimeout(this.showNextSlide.bind(this), this.faderSpeed);
          }

        connectedCallback() {
            this.slides.forEach((el, index) => {
                // el.dataset.width = el.offsetWidth + 1 + 'px';
                if (index === 0) {
                    el.classList.add('active');
                }
            });
            // this.fadeable.style.width = this.slideFirst.dataset.width
            this.showNextSlide();
        }

        disconnectedCallback() {
        }
      }
    );
  }